import React, { useEffect, useState } from "react";
import logo from "../assetsWeb/images/header-logo.png";
import footerlogo from "../assetsWeb/images/footer-logo.png";
import googlee from "../assetsWeb/images/Google_Play_Store_badge_EN.png";
import applee from "../assetsWeb/images/Download_on_the_App_Store_RGB_blk.png";
import { Link, useNavigate } from "react-router-dom";
import { FaRegCircleUser } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { createOrder } from "../actions/orderActions";
import { userLogout } from "../actions/authActions";
import SearchedByMap from "../components/SearchedByMap";

const HomeCheckoutPage = () => {
  const auth = useSelector((state) => state.auth);
  const users = useSelector((state) => state.users);
  const items = useSelector((state) => state.items);
  const { itemsDetails } = useSelector((state) => state.items);
  console.log(itemsDetails);
  const dispatch = useDispatch();
  console.log(auth, "auth");
  console.log(users, "users");

  const [values, setValues] = useState({
    userId: auth?.user?.id,
    storeId: "",
    itemsId: [],
    // orderNo: "",
    paymentType: "COD",
    // firstName: auth?.user?.firstName,
    // lastName: auth?.user?.lastName,
    // phone: auth?.user?.phone,
    // email: auth?.user?.email,
    address: "",
    totalAmount: "",
    status: "", // valid ?
  });
  console.log(values, "values");

  const handleChange = (fieldName) => (event) => {
    setValues({
      ...values,
      [fieldName]: event.target.value,
    });
  };
  // Calculate total price dynamically
  const calculateTotal = () => {
    return (
      values.itemsId?.reduce(
        (total, item) => total + (item.quantity || 1) * (item.sellPrice || 0),
        0
      ) || 0
    );
  };

  const orderData = {
    userId: auth?.user?.id,
    storeId: values.storeId,
    itemsId: itemsDetails,
    // itemsId: values.itemsId,
    // firstName: values.firstName,
    // lastName: values.lastName,
    // phone: values.phone,
    // email: values.email,
    address: values.address,
    paymentType: values.paymentType,
    totalAmount: calculateTotal(),
    // status: values.status, // valid ?
  };

  // State for order
  const [order, setOrder] = useState([]);

  // Initialize order state with itemsDetails
  useEffect(() => {
    setValues({
      ...values,
      itemsId: itemsDetails,
    });
  }, [itemsDetails]);

  // Handle increasing quantity
  const increaseQuantity = (id) => {
    setValues({
      ...values,
      itemsId: values.itemsId.map((item) =>
        item.id === id ? { ...item, quantity: (item.quantity || 1) + 1 } : item
      ),
    });
  };

  const decreaseQuantity = (id) => {
    setValues({
      ...values,
      itemsId: values.itemsId
        .map((item) =>
          item.id === id ? { ...item, quantity: item.quantity - 1 } : item
        )
        .filter((item) => item.quantity > 0), // Remove items with quantity 0
    });
  };

  let navigate = useNavigate();
  const navigateUser = () => {
    navigate("/order-confirm");
  };
  // const handlePhone = (fieldName) => (event) => {
  //   const numericValue = event.target.value.replace(/\D/g, "");
  //   let formattedValue = "";
  //   if (numericValue.length > 0) {
  //     formattedValue = `(${numericValue.slice(0, 3)}`;
  //   }
  //   if (numericValue.length > 3) {
  //     formattedValue += `)${numericValue.slice(3, 6)}`;
  //   }
  //   if (numericValue.length > 6) {
  //     formattedValue += `-${numericValue.slice(6, 10)}`;
  //   }
  //   setValues({
  //     ...values,
  //     [fieldName]: formattedValue,
  //   });
  // };
  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   for (let key of Object.keys(orderData)) {
  //     if (orderData[key] === "") {
  //       delete orderData[key];
  //     }
  //   }
  //   dispatch(createOrder(orderData, navigateUser));
  // };
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Group items by storeId
    const storeGroupedItems = values.itemsId.reduce((acc, item) => {
      const storeId = item?.storeId?.id || item.storeId; // depends on your structure
      if (!acc[storeId]) {
        acc[storeId] = {
          storeId,
          storeName: item?.storeId?.name || "", // optional
          items: [],
        };
      }
      acc[storeId].items.push(item);
      return acc;
    }, {});

    // Loop through each store and dispatch an order
    for (const storeId in storeGroupedItems) {
      const grouped = storeGroupedItems[storeId];

      const orderData = {
        userId: auth?.user?.id,
        storeId: grouped.storeId,
        itemsId: grouped.items,
        address: values.address,
        paymentType: values.paymentType,
        totalAmount: grouped.items.reduce(
          (acc, item) => acc + item.quantity * item.sellPrice,
          0
        ),
      };

      // Remove empty fields (optional cleanup)
      for (let key of Object.keys(orderData)) {
        if (orderData[key] === "") {
          delete orderData[key];
        }
      }

      // Dispatch the order (can await if needed)
      await dispatch(createOrder(orderData, navigateUser));
    }
  };

  const navigateHome = () => {
    navigate("/");
  };
  const logout = async (e) => {
    await dispatch(
      userLogout({ refreshToken: auth.tokens.refresh.token, navigateHome })
    );
  };

  return (
    <>
      <div className="bitefooflyheader-section ">
        <div className="container-fluid mb-3">
          <div className="row">
            <div className="riawiza-header-img">
              <nav className="navbar navbar-expand-lg navbar-light bg-light-subtle ">
                <div className="container">
                  {/* <!-- Logo --> */}
                  <Link className="navbar-brand" to="/">
                    <img
                      src={logo}
                      alt="Logo"
                      id="logsedf"
                      style={{ width: "52%" }}
                    />
                  </Link>
                  {/* <!-- Toggle button for small screens --> */}
                  <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                  >
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  {/* <!-- Navbar links --> */}
                  <div
                    className="collapse navbar-collapse justify-content-end"
                    id="navbarSupportedContent"
                  >
                    <ul className="navbar-nav">
                      <li className="nav-item">
                        <Link
                          to="/all"
                          role="button"
                          className="button-21"
                          style={{ marginRight: "20px", color: "#000" }}
                        >
                          <span className="icon-user">
                            <i
                              className="fa-solid fa-cart-shopping"
                              title="Show cart"
                            ></i>
                          </span>{" "}
                        </Link>

                        {auth?.user?.role === "user" ? (
                          <button
                            // to="/login"
                            className="button-21"
                            role="button"
                            style={{ marginRight: "20px", color: "#000" }}
                            onClick={logout}
                          >
                            <span className="icon-user">
                              <FaRegCircleUser />
                            </span>{" "}
                            &nbsp;Logout
                          </button>
                        ) : (
                          <>
                            <Link
                              to="/sign-up"
                              className="button-21"
                              role="button"
                              style={{ marginRight: "20px", color: "#000" }}
                            >
                              <span className="icon-user">
                                <FaRegCircleUser />
                              </span>{" "}
                              &nbsp;Sign up
                            </Link>
                            <Link
                              to="/login"
                              className="button-21"
                              role="button"
                              style={{ marginRight: "20px", color: "#000" }}
                            >
                              <span className="icon-user">
                                <FaRegCircleUser />
                              </span>{" "}
                              &nbsp;Login
                            </Link>
                          </>
                        )}

                        {values?.itemsId?.length > 0 ? (
                          <Link
                            to="/checkout"
                            role="button"
                            className="button-21"
                            style={{ marginRight: "20px", color: "#000" }}
                          >
                            <span className="icon-user">
                              <i
                                className="fa-solid fa-bag-shopping"
                                title="Checkout"
                              ></i>{" "}
                              {values?.itemsId?.length}{" "}
                              {/* Display count of array length */}
                            </span>{" "}
                          </Link>
                        ) : (
                          <Link
                            to="/#"
                            role="button"
                            className="button-21"
                            style={{ marginRight: "20px", color: "#000" }}
                          >
                            <span className="icon-user">
                              <i
                                className="fa-solid fa-bag-shopping"
                                title="Checkout"
                              ></i>{" "}
                              {values?.itemsId?.length || 0}{" "}
                            </span>{" "}
                          </Link>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </div>
      {values?.itemsId?.length > 0 ? (
        <div className="categ-section">
          <br />
          <br />
          <div className="categories-container">
            <div className="checkout-container">
              <h2>Details</h2>
              {/* <h2>Sign Up</h2> */}
              <form id="checkout-form">
                {auth && auth.user === null ? (
                  <>
                    <br />
                    <Link
                      to="/login"
                      type="submit"
                      className="btn btn-sm"
                      style={{
                        backgroundColor: "#28B8EC",
                        width: "100%",
                        color: "#fff",
                      }}
                    >
                      Log In
                    </Link>
                    <br />
                    <p style={{ textAlign: "center", paddingTop: "15px" }}>
                      OR
                    </p>
                    {/* <br /> */}
                    <Link
                      to="/sign-up"
                      type="submit"
                      className="btn btn-sm"
                      style={{
                        backgroundColor: "#28B8EC",
                        width: "100%",
                        color: "#fff",
                      }}
                    >
                      Sign Up
                    </Link>
                  </>
                ) : (
                  auth.user.role === "user" && (
                    <>
                      <div className="form-group" style={{ display: "flex" }}>
                        <strong>Name: </strong>
                        <div>
                          &nbsp;{" "}
                          {auth.user.firstName + " " + auth.user.lastName}
                        </div>
                      </div>
                      <div className="form-group" style={{ display: "flex" }}>
                        <strong>Email: </strong>
                        <div>&nbsp; {auth.user.email}</div>
                      </div>
                      <div className="form-group" style={{ display: "flex" }}>
                        <strong>Phone: </strong>
                        <div>&nbsp; {auth.user.phone}</div>
                      </div>

                      <div
                        style={{ marginTop: "1rem", marginBottom: "0.5rem" }}
                      >
                        {/* <strong style={{ fontSize: "1rem", color: "#001c3d" }}>
                          Address Info
                        </strong> */}
                        <hr style={{ margin: "0.3rem 0" }} />
                      </div>
                      {/* <div className="form-group" style={{ display: "flex" }}>
                      <strong>Address: </strong>
                      <div>&nbsp; {auth.user.address}</div>
                      &nbsp;
                      <input
                          type="text"
                          className="form-control"
                          placeholder="Enter address details"
                          value={values.address}
                          onChange={handleChange("address")}
                          required
                        />
                      </div> */}
                      <SearchedByMap values={values} setValues={setValues} />

                      {/* <div className="form-group">
                      <strong>Payment Method: </strong>
                      <select className="form-select">
                        <option value="0" selected disabled>
                          Select payment method
                        </option>
                        <option value="creditcard">Credit Card</option>
                        <option value="paypal">Paypal</option>
                      </select>
                    </div> */}
                    </>
                  )
                )}
              </form>
            </div>
            {/* <div className="checkout-container">
              <h2>Checkout</h2>
              <form id="checkout-form" onSubmit={handleSubmit}>
                <h3>Order Summary</h3>
                <div id="order-summary">
                  <p>
                    Store Name: <span id="order-number">123456</span>
                  </p>
                  <table className="table table-striped table-hover">
                    <thead className="thead-light">
                      <tr>
                        <th>Item</th>
                        <th>Quantity</th>
                        <th>Price</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {values?.itemsId?.length > 0 &&
                        values?.itemsId?.map((item) => (
                          <tr key={item.id}>
                            <td>{item.name}</td>
                            <td
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  width: "15px",
                                  height: "22px",
                                  color: "antiquewhite",
                                  background: "rgb(0, 166, 153)",
                                  borderRadius: "25px",
                                  textAlign: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => decreaseQuantity(item.id)}
                              >
                                −
                              </div>
                              <span> {item.quantity} </span>
                              <div
                                onClick={() => increaseQuantity(item.id)}
                                style={{
                                  width: "15px",
                                  height: "22px",
                                  color: "antiquewhite",
                                  background: "rgb(0, 166, 153)",
                                  borderRadius: "25px",
                                  textAlign: "center",
                                  cursor: "pointer",
                                }}
                              >
                                +
                              </div>
                            </td>
                            <td>${item.sellPrice}</td>
                            <td>${item.quantity * item.sellPrice}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "20px",
                      padding: "25px",
                    }}
                  >
                    <p>
                      <strong>Total: </strong>
                    </p>
                    <p>
                      <strong>
                        $
                        {values?.itemsId?.reduce(
                          (acc, item) => acc + item.quantity * item.sellPrice,
                          0
                        )}
                      </strong>
                    </p>
                  </div>
                </div>

                {!values.userId ||
                // !values.storeId ||
                // !values.address ||
                values.itemsId.length === 0 ? (
                  <button
                    type="submit"
                    className="btn btn-sm "
                    style={{
                      backgroundColor: "#696969",
                      width: "100%",
                      color: "#fff",
                      cursor: "not-allowed",
                    }}
                    disabled
                  >
                    Place Order
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-sm "
                    style={{
                      backgroundColor: "#28B8EC",
                      width: "100%",
                      color: "#fff",
                    }}
                  >
                    Place Order
                  </button>
                )}
              </form>
            </div> */}
            <div className="checkout-container">
              <h2>Checkout</h2>
              <form id="checkout-form" onSubmit={handleSubmit}>
                <h3>Order Summary</h3>
                <div id="order-summary">
                  {Object.entries(
                    values.itemsId.reduce((grouped, item) => {
                      const storeKey = item?.storeId?.id;
                      if (!grouped[storeKey]) {
                        grouped[storeKey] = {
                          storeName: item?.storeId?.name,
                          items: [],
                        };
                      }
                      grouped[storeKey].items.push(item);
                      return grouped;
                    }, {})
                  ).map(([storeId, { storeName, items }]) => (
                    <div
                      key={storeId}
                      className="mb-4 border p-3 rounded shadow-sm"
                    >
                      <h5 className="mb-3">
                        Store: <strong>{storeName}</strong>
                      </h5>
                      <table className="table table-striped table-hover">
                        <thead className="thead-light">
                          <tr>
                            <th>Item</th>
                            <th style={{ width: "100px" }}>Quantity</th>
                            <th>Price</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((item) => (
                            <tr key={item.itemId}>
                              <td
                                style={{
                                  maxWidth: "110px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {item.name}
                              </td>
                              <td>
                                {/* <button
                                  style={{
                                    width: "15px",
                                    height: "22px",
                                    color: "antiquewhite",
                                    background: "rgb(0, 166, 153)",
                                    borderRadius: "25px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => decreaseQuantity(item.id)}
                                >
                                  −
                                </button>{" "} */}
                                {item.quantity}
                                {/* {" "}
                                <button
                                  onClick={() => increaseQuantity(item.id)}
                                  style={{
                                    width: "15px",
                                    height: "22px",
                                    color: "antiquewhite",
                                    background: "rgb(0, 166, 153)",
                                    borderRadius: "25px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                >
                                  +
                                </button> */}
                              </td>
                              <td>${item.sellPrice}</td>
                              <td>${item.quantity * item.sellPrice}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="text-end pe-2">
                        <strong>
                          Subtotal: $
                          {items.reduce(
                            (acc, item) => acc + item.quantity * item.sellPrice,
                            0
                          )}
                        </strong>
                      </div>
                    </div>
                  ))}

                  {/* Grand Total */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      fontSize: "20px",
                      padding: "20px 0",
                      borderTop: "1px solid #ccc",
                      marginTop: "20px",
                    }}
                  >
                    <p>
                      <strong>Grand Total:</strong>
                    </p>
                    <p>
                      <strong>
                        $
                        {values.itemsId.reduce(
                          (acc, item) => acc + item.quantity * item.sellPrice,
                          0
                        )}
                      </strong>
                    </p>
                  </div>
                </div>

                {/* Submit button */}
                {!values.userId ||
                !values?.address?.address ||
                values.itemsId.length === 0 ? (
                  <button
                    type="submit"
                    className="btn btn-sm"
                    style={{
                      backgroundColor: "#696969",
                      width: "100%",
                      color: "#fff",
                      cursor: "not-allowed",
                    }}
                    disabled
                  >
                    Place Order
                  </button>
                ) : (
                  <button
                    type="submit"
                    className="btn btn-sm"
                    style={{
                      backgroundColor: "#28B8EC",
                      width: "100%",
                      color: "#fff",
                    }}
                  >
                    Place Order
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <p>Your cart is empty.</p>
          <Link
            to="/all"
            style={{
              background: "#28B8EC",
              color: "white",
              padding: "10px 20px",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Go Back to Shopping
          </Link>
        </div>
      )}

      <div className="footer-section">
        <footer>
          <h3
            style={{
              display: "flex",
            }}
          >
            <a className="navbar-brand" href="#">
              <img
                src={footerlogo}
                alt="Logo"
                id="logsedf"
                style={{ width: "52%" }}
              />
            </a>
          </h3>
          <div className="footer-container">
            <div className="footer-column">
              {/* <h3>Let’s do it together</h3> */}
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Let’s do it together
                  </a>
                </li>
                <li>
                  <a href="#">Career</a>
                </li>
                <li>
                  <a href="#">Partner</a>
                </li>
                <li>
                  <a href="#">Couriers</a>
                </li>
                <li>
                  <a href="#">Business</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Link of Interest
                  </a>
                </li>
                <li>
                  <a href="#">About Us</a>
                </li>
                <li>
                  <a href="#">FAQs</a>
                </li>
                <li>
                  <a href="#">Drovi Prime</a>
                </li>
                <li>
                  <a href="#">Blog</a>
                </li>
                <li>
                  <a href="#">Contact Us</a>
                </li>
                <li>
                  <a href="#">Security</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <ul>
                <li>
                  <a href="#" style={{ fontSize: "large", fontWeight: "bold" }}>
                    Follow us
                  </a>
                </li>
                <li>
                  <a href="#">Facebook</a>
                </li>
                <li>
                  <a href="#">Twitter</a>
                </li>
                <li>
                  <a href="#">Instagram</a>
                </li>
              </ul>
            </div>
            <div className="footer-column">
              <div className="app-icons">
                <ul>
                  <li>
                    <a href="#">
                      <img src={googlee} alt="Google Play" />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <img src={applee} alt="App Store" />
                    </a>
                  </li>
                  <li>
                    <a href="#">Facebook</a>
                  </li>
                  <li>
                    <a href="#">Twitter</a>
                  </li>
                  <li>
                    <a href="#">Instagram</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>All Rights Reserved. Iconictek Company © 2024</p>
          </div>
        </footer>
      </div>
    </>
  );
};

export default HomeCheckoutPage;
